import React, { ReactNode } from 'react';

import { Close } from 'components/Icons';
import styled from 'styled-components';

interface IHeader {
  text?: string;
  extra?: ReactNode;
  prefix?: ReactNode;
  className?: string;
  onClose?: () => void;
}

// Estilos utilizando styled-components
const HeaderWrapper = styled.header`
  gap: 2rem;
  display: flex;
  align-items: center;

  margin-bottom: 1.5rem;
  font-size: 24px
  font-weight:  bold;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 24px 32px;
`;

const Title = styled.div`
  gap: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 24px;

  font-weight: 700;
`;

export const Header = ({
  text,
  extra,
  prefix,
  onClose,
  className = '',
}: IHeader) => {
  return (
    <HeaderWrapper className={className} data-testid="drawer-header">
      <Title>
        {prefix}
        <span>{text}</span>
        {extra}
      </Title>
      <span
        onClick={onClose}
        data-testid="close-button"
        style={{ cursor: 'pointer' }}
      >
        <Close />
      </span>
    </HeaderWrapper>
  );
};
